module.exports = __webpack_public_path__ + "static/media/repeat.0c5f9b61.svg";